import PrivacyPolicy from "./pages/PrivacyPolicy"
import PageNotFound from "./pages/PageNotFound";

let routes = [
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy,
    },
    {
        path: '/main-site',
        name: 'main-site',
        beforeEnter() {location.href = 'https://www.heatremotesensing.com/'}
    },
    {
        //404 Page as default
        path: "*",
        name: 'not-found',
        component: PageNotFound
    },
];

export default routes;
